document.addEventListener('DOMContentLoaded', () => {
  const featureCards = document.querySelectorAll('.feature__card');

  featureCards.forEach((card) => {
    card.addEventListener('click', () => {
      const targetId = card.getAttribute('data-modal-target');
      document.getElementById(targetId).style.display = 'block';
      document.body.classList.add('no-scroll');
    });
  });

  const closeButtons = document.querySelectorAll('.feature__modal-close');
  closeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      document.querySelectorAll('.feature__modal').forEach((modal) => {
        modal.style.display = 'none';
      });

      document.body.classList.remove('no-scroll');
    });
  });

  document.querySelectorAll('.feature__modal-overlay').forEach((overlay) => {
    overlay.addEventListener('click', (event) => {
      if (event.target !== overlay) {
        return;
      }

      document.querySelectorAll('.feature__modal').forEach((modal) => {
        modal.style.display = 'none';
      });

      document.body.classList.remove('no-scroll');
    });
  });

  document
    .querySelector('.company-overview__more--display')
    .addEventListener('click', (event) => {
      if (!event.target.classList.contains('company-overview__more--display'))
        return;

      document
        .querySelectorAll('.company-overview__description-container--hidden')
        .forEach((el) => {
          if (window.matchMedia('(max-width: 767px)').matches) {
            el.style.display = 'block';
          } else {
            el.style.display = 'flex';
          }
        });

      event.target.style.display = 'none';

      document.querySelector('.company-overview__more--hidden').style.display =
        'flex';
    });

  document
    .querySelector('.company-overview__more--hidden')
    .addEventListener('click', (event) => {
      if (!event.target.classList.contains('company-overview__more--hidden'))
        return;

      document
        .querySelectorAll('.company-overview__description-container--hidden')
        .forEach((el) => {
          el.style.display = 'none';
        });

      event.target.style.display = 'none';

      document.querySelector('.company-overview__more--display').style.display =
        'flex';
    });

  document
    .querySelector('.service-flow__more--display')
    .addEventListener('click', (event) => {
      if (!event.target.classList.contains('service-flow__more--display'))
        return;

      document
        .querySelectorAll('.service-flow__text-item--hidden')
        .forEach((el) => {
          el.style.display = 'block';
        });

      document
        .querySelector('[data-target="transparent-target"]')
        .classList.remove('service-flow__text-item--transparent');

      event.target.style.display = 'none';

      document.querySelector('.service-flow__more--hidden').style.display =
        'flex';
    });

  document
    .querySelector('.service-flow__more--hidden')
    .addEventListener('click', (event) => {
      if (!event.target.classList.contains('service-flow__more--hidden'))
        return;

      document
        .querySelectorAll('.service-flow__text-item--hidden')
        .forEach((el) => {
          el.style.display = 'none';
        });

      document
        .querySelector('[data-target="transparent-target"]')
        .classList.add('service-flow__text-item--transparent');

      event.target.style.display = 'none';

      document.querySelector('.service-flow__more--display').style.display =
        'flex';
    });
});
